import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDLEaIWVraQFqnumUrUXrtChxgYtLBk-ys",
  authDomain: "emmapro-logistix.firebaseapp.com",
  projectId: "emmapro-logistix",
  storageBucket: "emmapro-logistix.firebasestorage.app",
  messagingSenderId: "232973237459",
  appId: "1:232973237459:web:75b04ea5c6bab361a52826",
  measurementId: "G-GXJBWHKXG0"
};

const app = initializeApp(firebaseConfig);
const analyticsPromise = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);

const trackEvent = async (eventName, eventParams = {}) => {
  const analytics = await analyticsPromise;

  if (!analytics) {
    return;
  }

  logEvent(analytics, eventName, eventParams);
};

export { app, trackEvent };
